import { create } from "zustand"
import type { Artikal } from "../api/catalog"

export interface CartItem {
    sifra: string
    nazivArtikla: string
    cijena: number
    kolicina: number
    jedMj: string
    napomena?: string
    monitor?: number
}

interface OrderState {
  items: CartItem[]
  addItem: (artikal: Artikal, kolicina?: number) => void
  updateQuantity: (sifra: string, kolicina: number) => void
  updateNapomena: (sifra: string, napomena: string) => void
  removeItem: (sifra: string) => void
  clear: () => void
  total: () => number
  totalCount: () => number
}

export const useOrderStore = create<OrderState>((set, get) => ({
  items: [],
    addItem: (artikal, kolicina = 1) => set((state) => {
        const existing = state.items.find(i => i.sifra === artikal.sifra)
        if (existing) {
            return { items: state.items.map(i => i.sifra === artikal.sifra ? { ...i, kolicina: i.kolicina + kolicina } : i) }
        }
        return {
            items: [...state.items, {
                sifra: artikal.sifra,
                nazivArtikla: artikal.nazivArtikla,
                cijena: artikal.cijena,
                kolicina,
                jedMj: artikal.jedMj || "KOM",
                monitor: artikal.monitor
            }]
        }
    }),
  updateQuantity: (sifra, kolicina) => set((state) => ({
    items: kolicina <= 0 ? state.items.filter(i => i.sifra !== sifra) : state.items.map(i => i.sifra === sifra ? { ...i, kolicina } : i)
  })),
  updateNapomena: (sifra, napomena) => set((state) => ({
    items: state.items.map(i => i.sifra === sifra ? { ...i, napomena } : i)
  })),
  removeItem: (sifra) => set((state) => ({ items: state.items.filter(i => i.sifra !== sifra) })),
  clear: () => set({ items: [] }),
  total: () => get().items.reduce((sum, i) => sum + i.cijena * i.kolicina, 0),
  totalCount: () => get().items.reduce((sum, i) => sum + i.kolicina, 0)
}))
